import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import ListeConnect from '@/views/ListeConnect'
import ViewConnect from '@/views/ViewConnect'
import ListeNouvelleDemande from "../views/ListeNouvelleDemande";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Login',
        component: Login
    },
    {
        path: '/listeConnect',
        name: 'ListeConnect',
        component: ListeConnect,
        meta: { requiredAuth: true }
    },
    {
        path: '/ViewConnect/:id',
        name: 'ViewConnect',
        component: ViewConnect,
        props: true,
        meta: { requiredAuth: true }
    },
    {
        path: '/ListeNouvelleDemande',
        name: 'ListeNouvelleDemande',
        component: ListeNouvelleDemande,
        meta: { requiredAuth: true }
    }
]

const router = new VueRouter( {
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('user')
    if (to.matched.some(record => record.meta.requiredAuth) && loggedIn == null){
        next({ name: 'Login'})
        return false;
    }
    next()
})

export default router
